export const STATUS_PENDIENTE = "PENDIENTE";
export const STATUS_EXCLUIDO = "EXCLUIDO";
export const STATUS_CANCELADO = "CANCELADO";
export const STATUS_ASIGNADO = "REP ASIGNADO";
export const STATUS_VISITA_INICIADA = "VISITA INICIADA";
export const STATUS_VISITA_EN_PROCESO = "VISITA EN PROCESO";
export const STATUS_VISITA_FINALIZADA = "VISITA FINALIZADA";
export const STATUS_ERROR = "ERROR";
export const STATUS_FATAL = "FATAL";
export const STATUS_PENDIENTE_DE_VALIDAR = "PENDIENTE DE VALIDAR";
export const STATUS_VALIDACION_EN_PROCESO = "VALIDACIÓN EN PROCESO";
export const STATUS_VALIDACION_CORRECTA = "VALIDACIÓN CORRECTA";
export const STATUS_PENDIENTE_DE_AGRUPAR = "PENDIENTE DE AGRUPACIÓN";
export const STATUS_PENDIENTE_ENVIO_SFT = "PENDIENTE DE ENVÍO A SFT";
export const STATUS_ENVIO_SFT_PROCESO = "ENVÍO A SFT EN PROCESO";
export const STATUS_ENVIADO_SFT = "ENVIADO A SFT";
export const STATUS_ERROR_ENVIAR_SFT = "ERROR AL ENVIAR A SFT";
export const STATUS_VENCIDO = "VENCIDO";

export const STATUS_NUM_PENDIENTE = "PENDIENTE";
export const STATUS_NUM_EXCLUIDO = "EXCLUIDO";
export const STATUS_NUM_CANCELADO = "CANCELADO";
export const STATUS_NUM_ASIGNADO = "ASIGNADO";
export const STATUS_NUM_VISITA_INICIADA = "VISITA_INICIADA";
export const STATUS_NUM_VISITA_EN_PROCESO = "VISITA_EN_PROCESO";
export const STATUS_NUM_VISITA_FINALIZADA = "VISITA_FINALIZADA";
export const STATUS_NUM_ERROR = "ERROR";
export const STATUS_NUM_FATAL = "FATAL";
export const STATUS_NUM_PENDIENTE_DE_VALIDAR = "PENDIENTE_DE_VALIDAR";
export const STATUS_NUM_VALIDACION_EN_PROCESO = "VALIDACION_EN_PROCESO";
export const STATUS_NUM_VALIDACION_CORRECTA = "VALIDACION_CORRECTA";
export const STATUS_NUM_PENDIENTE_DE_AGRUPAR = "PENDIENTE_DE_AGRUPAR";
export const STATUS_NUM_PENDIENTE_ENVIO_SFT = "PENDIENTE_ENVIO_SFT";
export const STATUS_NUM_ENVIO_SFT_PROCESO = "ENVIO_SFT_PROCESO";
export const STATUS_NUM_ENVIADO_SFT = "ENVIADO_SFT";
export const STATUS_NUM_ERROR_ENVIAR_SFT = "ERROR_ENVIAR_SFT";
export const STATUS_NUM_VENCIDO = "VENCIDO";

export const STATUS_TABLE = {
  PENDIENTE: { name: STATUS_PENDIENTE, color: "gray", icon: "far fa-user" }
  , EXCLUIDO: { name: STATUS_EXCLUIDO, color: "red", icon: "fas fa-times-circle" }
  , CANCELADO: { name: STATUS_CANCELADO, color: "gray", icon: "fas fa-times-circle" }
  , ASIGNADO: { name: STATUS_ASIGNADO, color: "#0077BC", icon: "fas fa-user-check" }
  , VISITA_INICIADA: { name: STATUS_VISITA_INICIADA, color: "#f49d00", icon: "fas fa-sign-in-alt" }
  , VISITA_EN_PROCESO: { name: STATUS_VISITA_EN_PROCESO, color: "#a755f6", icon: "fas fa-sign-in-alt" }
  , VISITA_FINALIZADA: { name: STATUS_VISITA_FINALIZADA, color: "#147f3d", icon: "fas fa-sign-in-alt" }
  , ERROR: { name: STATUS_ERROR, color: "red", icon: "fas fa-exclamation-circle" }
  , FATAL: { name: STATUS_FATAL, color: "red", icon: "fas fa-exclamation-circle" }
  , PENDIENTE_DE_VALIDAR: { name: STATUS_PENDIENTE_DE_VALIDAR, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , VALIDACION_EN_PROCESO: { name: STATUS_VALIDACION_EN_PROCESO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , VALIDACION_CORRECTA: { name: STATUS_VALIDACION_CORRECTA, color: "green", icon: "fas fa-check" }
  , PENDIENTE_DE_AGRUPAR: { name: STATUS_PENDIENTE_DE_AGRUPAR, color: "green", icon: "fas fa-spinner fa-pulse" }
  , PENDIENTE_ENVIO_SFT: { name: STATUS_PENDIENTE_ENVIO_SFT, color: "#0077BC", icon: "fas fa-history" }
  , ENVIO_SFT_PROCESO: { name: STATUS_ENVIO_SFT_PROCESO, color: "#0077BC", icon: "fas fa-spinner fa-pulse" }
  , ENVIADO_SFT: { name: STATUS_ENVIADO_SFT, color: "green", icon: "fas fa-paper-plane" }
  , ERROR_ENVIAR_SFT: { name: STATUS_ERROR_ENVIAR_SFT, color: "red", icon: "fas fa-exclamation-circle" }
  , VENCIDO: { name: STATUS_VENCIDO, color: "gray", icon: "fas fa-calendar-times" }
};

export const STATUS_FORMULARIO_SELECT_REPORTE_VISITAS = [
  { code: STATUS_NUM_PENDIENTE, name: STATUS_PENDIENTE }
  , { code: STATUS_NUM_ASIGNADO, name: STATUS_ASIGNADO }
  , { code: STATUS_NUM_VISITA_INICIADA, name: STATUS_VISITA_INICIADA }
  , { code: STATUS_NUM_VISITA_EN_PROCESO, name: STATUS_VISITA_EN_PROCESO }
  , { code: STATUS_NUM_VISITA_FINALIZADA, name: STATUS_VISITA_FINALIZADA }
  , { code: STATUS_NUM_VALIDACION_CORRECTA, name: STATUS_VALIDACION_CORRECTA }
  , { code: STATUS_NUM_ERROR, name: STATUS_ERROR }
  , { code: STATUS_NUM_FATAL, name: STATUS_FATAL }
  , { code: STATUS_NUM_CANCELADO, name: STATUS_CANCELADO }
  , { code: STATUS_NUM_VENCIDO, name: STATUS_VENCIDO }
];


// WEBPACK FOOTER //
// ./src/constants/bases.js